import $ from 'jquery';

/**
 * Code for FYH drilldown modal
 */
var lastFyhModalButtonClicked = null;
var fyhDrilldownModal = $("#fyh-modal");

// get list of all buttons that open this modal
var fyhModalButtons = $(".fyh-modal-open");

$(function () {
    
    if( fyhDrilldownModal.length > 0 && fyhModalButtons.length > 0 ) {
        /**
         * Handle click events on the modal open buttons so that 
         * we can keep track which one opened the modal so we can
         * restore focus to this element when the modal closes
         */
        fyhModalButtons.on("click", function(){
            lastFyhModalButtonClicked = $(this);
            $(fyhDrilldownModal).foundation('open');
            if (lastFyhModalButtonClicked.data("opener") == "fyhpage") {
                // Make sure to flag this to true. This is use in fyh-state-filter click function in app.js to know the modal opener
                $("#hfFYHStateRegionFilterWasClicked").val("true");
            }
        });

        // handle modal closing to restore focus to button that opened it
        fyhDrilldownModal.on("closed.zf.reveal", function() {
            if (lastFyhModalButtonClicked) {
                lastFyhModalButtonClicked.focus();
            }
            // Reset this flag to false. This is use in fyh-state-filter click function in app.js to know the modal opener
            $("#hfFYHStateRegionFilterWasClicked").val("false");
        });

        // Close the reveal of the drilldown on orientation change
        $(window).on('changed.zf.mediaquery', function (event, newSize, oldSize) {
            fyhDrilldownModal.foundation("close");
            // Reset this flag to false. This is use in fyh-state-filter click function in app.js to know the modal opener
            $("#hfFYHStateRegionFilterWasClicked").val("false");
        });
    }
    
})
